/**
 *
 * Asynchronously loads the component for Reviews
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
